// extracted by mini-css-extract-plugin
export default {"background":"Item_background__c2qDk","box":"Item_box__RZUKK","title":"Item_title__WqShq","location":"Item_location__5DNmL"};